























import { Component, Vue, Prop } from 'vue-property-decorator'
import { constants } from '@/helpers/constants';
import { Coupon } from '@/helpers/interfaces';

@Component
export default class CouponBoxListDisplayOnly extends Vue {
  @Prop({required: true}) couponList!: Coupon[]
  public CouponType = constants.CouponType

  get pageName(){
    return this.$route.name||""
  }

  goTo(){
    if(this.pageName === 'Home')
    this.$router.push({name: 'CouponCenter'})
  }

}
